export default {
  authorised: [
    {
      path: "/profile",
      name: "profile",
      component: () => import("@/modules/profile/views/ProfileForm.vue"),
    },
  ],
};
